import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
export function getName(firstName, lastName) {
  if (firstName && lastName) {
    return "".concat(firstName, " ").concat(lastName);
  }
  return firstName || lastName || '--';
}
export function getInitials(firstName, lastName) {
  if (firstName && lastName) {
    return "".concat(firstName[0]).concat(lastName[0]);
  }
  var name = firstName || lastName;
  return name ? name.slice(0, 2) : '--';
}